"use strict";

var React = require("react");
module.exports = React.createElement(
  "svg",
  { viewBox: "0 0 48 48" },
  React.createElement("path", { d: "M42.885 4H5.119a1.464 1.464 0 0 0-1.136 2.388l16.1 19.671v18.417a1.464 1.464 0 0 0 2.46 1.073l4.93-5.445a1.464 1.464 0 0 0 .49-1.093V26.027L44.021 6.388A1.464 1.464 0 0 0 42.885 4z" })
);

